import { render, staticRenderFns } from "./IdInstructionModal.vue?vue&type=template&id=2065a484&scoped=true&"
import script from "./IdInstructionModal.vue?vue&type=script&lang=js&"
export * from "./IdInstructionModal.vue?vue&type=script&lang=js&"
import style0 from "./IdInstructionModal.vue?vue&type=style&index=0&id=2065a484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2065a484",
  null
  
)

export default component.exports